import axios from "axios";

import { expiredTokenHandler } from "./ExpiredTokenHandler";

const createInstance = () => {
    // const apiPreUrl = store.getters['Url/setApiPreUrl'];
    const apiPreUrl = window.location.protocol + '//' + window.location.hostname + ':8008';
    //const frontPreUrl = window.location.protocol + '//' + window.location.host;
    //console.log('api', apiPreUrl);
    const instance = axios.create({ baseURL: apiPreUrl });
    return setInterceptor(instance);
}

const setInterceptor = (instance) => {
    instance.interceptors.request.use(function (config) {
        
        // config.headers.AccessToken = localStorage.getItem("AccessToken");
        if (!config.url.endsWith('/api/auth/login')) {
            config.headers.Authorization = `Bearer ${sessionStorage.getItem("AccessToken")}`;
        }
        //config.headers["Content-Type"] = "application/json";
        if (!(config.data instanceof FormData)) {
            config.headers["Content-Type"] = "application/json";
        }
        //config.headers['Access-Control-Allow-Origin'] = '*';


        // console.log('Sending Request to:', config.url);
        // console.log('Request Headers:', config.headers);

        return config;
    });

    instance.interceptors.response.use(
        async (response) => {
            if (response.status === 401) {
                return await expiredTokenHandler(response);
            }

            // console.log('Response from:', response.config.url);
            // console.log('Response Headers:', response.headers); 

            return response;
        },
        async (error) => {
            if (error.response && error.response.status === 401) {
                try {
                    return await expiredTokenHandler(error.response);
                } catch (e) {
                    return Promise.reject(e);
                }
            }
            //console.error('Response Error:', error);
            return Promise.reject(error);
        }
    );
    return instance;
}

const globalAxios = createInstance();

export default globalAxios;
